<template>
    <div class="w-full">
        <div class="bg-echoes-background-black p-4 rounded-xl">
            <div class="flex justify-center items-center mb-4">
                <h3 class="font-semibold text-white">Sale History</h3>
            </div>
            <div class="relative">
                <div class="absolute left-3 top-0 bottom-0 w-0.5 bg-echoes-border-light"></div>
                
                <div class="max-h-[325px] overflow-y-auto pl-8" ref="scrollContainer">
                    <ol class="relative text-gray-500">
                        <li class="relative" :class="index === history.length - 1 ? 'mb-2' : 'mb-8'" v-for="(step, index) in history" :key="step.id">
                            <span class="absolute flex items-center justify-center w-5 h-5 rounded-full -left-8 p-3" :class="currentStep === step.id ? 'current-step' : 'past-step'">
                                <i :class="getStepParams(step).icon"></i>
                            </span>
                            <div class="ml-2">
                                <h3 class="font-medium leading-tight text-sm" :class="currentStep === step.id ? 'text-echoes-primary' : 'text-white'">{{ getStepParams(step).title }}</h3>
                                <p class="text-sm text-gray-500 text-white py-1" v-if="step.message">
                                    <i class="uil uil-comment-alt-message text-xs mr-2"></i>
                                    {{ step.message }}
                                </p>
                                <p class="text-xs text-gray-500" v-if="step.created_at">{{ formatDate(step.created_at) }}</p>
                            </div>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </div>  
</template>

<script setup>
import { ref, defineProps, onMounted, nextTick } from 'vue';

const props = defineProps({
    sale: {
        type: Object,
        required: true
    }
})

const history = ref([])
const currentStep = ref(null)
const scrollContainer = ref(null)
const stepParams = {
    buyer_payment: {
        icon: 'uil uil-user-circle',
        title: 'Buyer Request'
    },
    seller_review: {
        icon: 'uil uil-keyhole-circle',
        title: 'Seller Review'
    },
    admin_review: {
        icon: 'uil uil-microscope',
        title: 'Admin Review'
    }
}

const historyOrderASC = () => {
    return [...props.sale.history].sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
}

const getStepParams = (step) => {
    return stepParams[step.step.name]
}

const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
}

const addNextStep = () => {
    const lastStep = history.value[history.value.length - 1].step.name
    const lastStatus = history.value[history.value.length - 1].status.name

    if(lastStep === 'buyer_payment' && lastStatus === 'reviewing') {
        history.value.push({
            step: { name: 'seller_review' }
        })
    }

    if(lastStep === 'admin_review' && lastStatus === 'returned') {
        history.value.push({
            step: { name: 'seller_review' }
        })
    }

    if(lastStep === 'seller_review' && lastStatus === 'reviewing') {
        history.value.push({
            step: { name: 'admin_review' }
        })
    }

    if(lastStep === 'admin_review' && lastStatus === 'ready') {
        history.value.push({
            step: { name: 'buyer_payment' }
        })
    }
}

const scrollToBottom = () => {
    if (scrollContainer.value) {
        scrollContainer.value.scrollTop = scrollContainer.value.scrollHeight
    }
}

onMounted(async () => {
    history.value = historyOrderASC()
    addNextStep()
    currentStep.value = history.value[history.value.length - 1].id
    
    // Aguarda o próximo tick para garantir que o DOM foi atualizado
    await nextTick()
    // Rola para o final da lista
    scrollToBottom()
})
</script>

<style scoped lang="postcss">
.past-step {
    @apply bg-gray-100 text-gray-600;
}
.current-step {
    @apply bg-echoes-primary text-echoes-background-gray rounded-full;
}

</style>